import { App } from 'vue'

export default function useDragWindowDirective (app: App) {
  app.directive('drag-window', {
    mounted (el: HTMLElement) {
      const header = el.querySelector('.drag-title') as HTMLElement
      if (!header) return

      header.style.cursor = 'move'
      let startX = 0; let startY = 0
      let initLeft = 0; let initTop = 0

      const onPointerDown = (e: PointerEvent) => {
        e.preventDefault()
        startX = e.clientX
        startY = e.clientY

        const style = getComputedStyle(el)
        initLeft = parseFloat(style.left) || el.offsetLeft || 0
        initTop = parseFloat(style.top) || el.offsetTop || 0

        document.addEventListener('pointermove', onPointerMove)
        document.addEventListener('pointerup', onPointerUp)
        header.setPointerCapture(e.pointerId)
      }

      const onPointerMove = (e: PointerEvent) => {
        const dx = e.clientX - startX
        const dy = e.clientY - startY
        el.style.left = initLeft + dx + 'px'
        el.style.top = initTop + dy + 'px'
      }

      const onPointerUp = () => {
        document.removeEventListener('pointermove', onPointerMove)
        document.removeEventListener('pointerup', onPointerUp)
      }

      header.addEventListener('pointerdown', onPointerDown)
    }
  })
}
